import { token } from '@atlaskit/tokens';

export const EPIC_VERSION_PROGRESS_BAR_HEIGHT = 5;
export const EPIC_VERSION_PROGRESS_BAR_HOVER_PADDING = 3;

export const LOADING_COLOR = token('color.skeleton');
export const TODO_COLOR = token('color.border');
export const IN_PROGRESS_COLOR = token('color.border.information');
export const DONE_COLOR = token('color.border.success');

export const PROGRESS_BAR_WRAPPER_TEST_ID =
	'software-backlog-panel.common.ui.progress-bar.progress-bar-wrapper';
